import React from 'react';
import {observer} from 'mobx-react';
import autobind from 'common/decorators/autobind.js';
import {DirectoryStoreContext} from 'core/stores/RootStore.js';
import {Toggle, Dropdown} from '@HealthShareAU/hs-component-library';
import {HEADER_SECTION, OFFERS_TELEHEALTH_FILTER,TOOLTIP_TELEHEALTH_TEXT,FACE_TO_FACE_ID,OFFERS_TEL_ID} from 'core/constants.js';
import {browserCheckForIE11} from 'core/utils.js';
import TooltipIE11 from './TooltipIE11';

export default
@observer
class DirectoryHeader extends React.Component {
    static contextType = DirectoryStoreContext;


    constructor(props) {
        super(props);
    
        this.scrollContainerRef = React.createRef();
    }

    componentDidMount() {
        const isTelDirectory =
            this.props?.offersTelehealth && this.props.telehealthDirectory;

        const {consultationTypes} = this.context

        // this searched sepcialty offer tel also in tel dir
        if (isTelDirectory) {
            this.context?.updateStore({
                selectedConsultationType: consultationTypes?.[1],
            });
        } else {
            this.context?.updateStore({
                selectedConsultationType: consultationTypes?.[0],
            });
        }
    }

    getHeading() {
        const {
            locality,
            specialty,
            interest,
            state,
            telehealthDirectory,
            rootStore: {
                paramStore: {isReferrals, isProUser, isClient},
            },
        } = this.context;
        let title =
            isReferrals || isProUser
                ? specialty.pluralProfessionalName
                : specialty.pluralName;
        if (isClient) return null;

        if (interest?.name) {
            title += ` with special interest "${interest.name}"`;
        }
        if (telehealthDirectory && state) {
            title += ` in ${state.name}`;
        } else if (locality) {
            title += ` in ${locality?.name} ${locality?.state?.name} ${locality?.postCode}`;
        }
        return title;
    }

    @autobind
    toggleTelehealthDirectory(event) {
        /*
         *   Triggers a redirect to the relevant directory page
         *     - checked: telehealth directory (telehealth-specialty in state)
         *     - unchecked: regular directory  (specialty in locality)
         */
        if (event && event.key === ' ') {
            // For space bar, prevent jumping to end of page
            event.preventDefault();
        }

        this.context.locationSearchAPI.updateStore({
            isLoading: true,
            results: [],
        });

        this.context.updateStore({
            bannerAdsHaveLoaded: false,
            telehealthDirectory: !this.context.telehealthDirectory,
            selectedConsultationType: this.context.consultationTypes[1],
        });

    
        window.location.assign(this.context.toggleDirectoryURL);
    }

    @autobind
    filterTelehealthDirectoryV2(isOfferTel, consultation) {
        if (isOfferTel) {
            this.toggleTelehealthDirectory();
        } else {
            this.context.updateStore({
                filterByTelehealth: !this.context.filterByTelehealth,
                selectedConsultationType: consultation,
            });
        }
    }

    @autobind
    filterTelehealthDirectory() {
        this.context.updateStore({
            filterByTelehealth: !this.context.filterByTelehealth,
        });
    }

    renderTelFilter(isOfferTel) {
        const {
            selectedConsultationType,
            consultationTypes,
        } = this.context;

        const isFaceToFaceChecked = selectedConsultationType.id === FACE_TO_FACE_ID

        const isTelehealthChecked = selectedConsultationType.id === OFFERS_TEL_ID;


        return (
            <TooltipIE11 text="Filter practitioners by consultation type — face-to-face or telehealth.">
                <div
                    className="filters-tel-section"
                    data-ga-object-type={HEADER_SECTION}
                    data-ga-selector={OFFERS_TELEHEALTH_FILTER}
                    data-testid={OFFERS_TELEHEALTH_FILTER}
                >
                    {/* FACE-TO-FACE */}
                    <Toggle
                        customClass='f2f-toggle'
                        name="consultation-mode"
                        checked={isFaceToFaceChecked}
                        type="radio"
                        text="Face-to-face"
                        onChange={() => {
                            const isTelDir = isOfferTel;
                            this.filterTelehealthDirectoryV2(
                                isTelDir,
                                consultationTypes[0],
                            );
                        }}
                    />
                    
                    <div className="tel-divider"></div>

                    {/* OFFERS TELEHEALTH */}
                    <Toggle
                        customClass='tel-toggle'
                        name="consultation-mode"
                        checked={isTelehealthChecked}
                        type="radio"
                        text="Offers Telehealth"
                        onChange={() => {
                            const isTelDir = isOfferTel;
                            this.filterTelehealthDirectoryV2(
                                isTelDir,
                                consultationTypes[1],
                            );
                        }}
                    />
                </div>
                </TooltipIE11>
        );
    }

    renderTelehealthFilter(emphasized) {
        const {
            telehealthDirectory,
            filterByTelehealth,
        } = this.context;
        return (
            <Toggle
                customClass={`filter${emphasized ? ' primary' : ''}`}
                checked={emphasized ? telehealthDirectory : filterByTelehealth}
                hasContainer
                isPriority={emphasized}
                onChange={
                    emphasized
                        ? this.toggleTelehealthDirectory
                        : this.filterTelehealthDirectory
                }
                text="Offers Telehealth"
                tooltip={
                    browserCheckForIE11() ? null : TOOLTIP_TELEHEALTH_TEXT
                }
                type="checkbox"
            />
        );
    }
    renderOfferTelFilterUI() {
        const {specialty} = this.context;

        const isEnableF2fFilter = this.context?.enableDirectoryF2fFilter;

        if (isEnableF2fFilter) {
            return this.renderTelFilter(specialty.offersTelehealth);
        } else {
            return this.renderTelehealthFilter(specialty.offersTelehealth);
        }
    }

    renderFilters() {
        const {
            genders,
            languages,
            specialty,
            selectedLanguage,
            selectedGender,
        } = this.context;

        const handleSelectFilter = (
            name,
            filterBy,
            filterOptions,
            filterName,
        ) => {
            const option = filterOptions.find(
                (opt) => opt.name === filterName,
            );
            this.context.updateStore({
                bannerAdsIsLoading: true,
                [filterBy]: option || {
                    code: 'any',
                    name: `Any ${name}`,
                },
            });
        };

        return (
            <>
                {this.renderOfferTelFilterUI()}
                <Dropdown
                    onChange={(languageOption) => {
                        handleSelectFilter(
                            'Language',
                            'selectedLanguage',
                            languages,
                            languageOption,
                        );
                    }}
                    options={languages}
                    side="left"
                    value={selectedLanguage.name}
                    width={200}
                />
                <Dropdown
                    onChange={(genderOption) => {
                        handleSelectFilter(
                            'Gender',
                            'selectedGender',
                            genders,
                            genderOption,
                        );
                    }}
                    options={genders}
                    side="left"
                    value={selectedGender.name}
                    width={180}
                />
            </>
        );
    }

    render() {
        const {
            rootStore: {
                paramStore: {isClient},
            },
        } = this.context;
        return (
            <header className="directory-header">
                {!isClient && <h1>{this.getHeading()}</h1>}
                <section className="filters">{this.renderFilters()}</section>
            </header>
        );
    }
}
